import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import RepVisitsOverviewFrame from './overview-frame';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query PendingCollegeRSVPs {
    viewer {
      id
      heAccount {
        id
        activeSubscriptions
      }
    }
  }
`;

const graphqlData = graphql(query);

export default SimpleLoadingComponent(graphqlData)(RepVisitsOverviewFrame);
